var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79166 17.3781C7.88762 16.2649 6.11631 14.9547 4.50945 13.471C3.37976 12.4025 2.51973 11.0998 1.99525 9.66282C1.05143 6.87525 2.15387 3.68402 5.23913 2.7396C6.86061 2.2437 8.63152 2.52713 9.99787 3.50123C11.3648 2.52831 13.135 2.24498 14.7566 2.7396C17.8419 3.68402 18.9523 6.87525 18.0084 9.66282C17.484 11.0998 16.6239 12.4025 15.4942 13.471C13.8874 14.9547 12.1161 16.2649 10.212 17.3781L10.0058 17.5L9.79166 17.3781Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.2812 5.87793C14.2157 6.16151 14.8797 6.95851 14.9627 7.89625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.c68ef488d3cfaf25bd5446aa23c3f2e7.svg";
export { ForwardRef as ReactComponent };